function scheduler_change(e) {
  const events = e.events // list of selected Scheduler events
  setTimeout(function () {
    const msg = events[events.length - 1].description.replaceAll(/((=0D)?=0A|\n)/g, '<' + 'br><' + 'br>').replaceAll(/[#]/g, "\\#")
    const title = ''
    const kendoWindowAssign = $('#windowForAssign')
    let popup

    function createAndShowPopup() {
      kendoWindowAssign.kendoWindow({
        width: '350px',
        modal: true,
        height: '600px',
        content: {
          template: msg
        },
        iframe: false,
        resizable: false,
        title,
        deactivate: function () {
          $('#scheduler').data('kendoScheduler').select(0)
        },
        draggable: false,
        visible: false
      })

      popup = $('#windowForAssign').data('kendoWindow')
      popup.open()
      var widthStr = $('#scheduler').css('width')
      var width = Number(widthStr.substring(0, widthStr.length - 2))
      $('.k-window').css('left', (width / 2) - 155)
      $('.k-window-title').text($(".k-state-selected[aria-selected='true'] .k-task").text())
    }
    createAndShowPopup()
    setTimeout(function () {
      $('.k-overlay').click(function () {
        popup.close()
      })
    }, 500)
  }, 10)
}

const API_KEY: string = window.API_KEY.value

const API_CACHE_GENERATION = 2

const SPREADSHEET: string = window.SPREADSHEET.value
const RANGE: string = window.RANGE.value

const START_DATE: string = window.START_DATE.value
const END_DATE: string = window.END_DATE.value

const ENABLE_CACHING: boolean = true

var response;
window.response = response;
var sheetsData: { title: string; people: string; detail: string; start: Date; end: Date; location: string; priority: number }[];


(function () {
  try {
    // window['localStorage'].removeItem('gsheetsResponse')
    // window['localStorage'].removeItem('gsheetsResponseTimestamp')
    // window['localStorage'].removeItem('gsheetsResponseGeneration')
    const contents = JSON.parse(window['localStorage'].getItem('gsheetsResponse' + START_DATE))
    const timestamp = new Date(window['localStorage'].getItem('gsheetsResponseTimestamp' + START_DATE))
    const generation: number = JSON.parse(window['localStorage'].getItem('gsheetsResponseGeneration' + START_DATE))
    if (contents && timestamp.getDay() === (new Date()).getDay() && generation >= API_CACHE_GENERATION) {
      response = contents // not until the event gets going
    } else {
      //window['localStorage'].clear()
    }
  } catch(e) { 
    console.error(e);
  }
})()

async function updateLocationFilter() {
  var placeholder = " Filter Location ..."
  var uniqueData = { [placeholder]: '' };
  for (const item of sheetsData) {
    uniqueData[item.location] = item.location;
  }
  var uniqueDataSource = Object.keys(uniqueData).map(x => ({ text: x, value: x }));
  uniqueDataSource.sort((a, b) => (a.value > b.value) ? 1 : -1)
  $("#locationfilter").kendoDropDownList({
    dataTextField: "text",
    dataValueField: "value",
    dataSource: uniqueDataSource,
    index: 0,
    change: function onChange(_) {
      var update = this.value() === placeholder ? '' : '[' + this.value() + ']';
      fetchCalendarData(update)
      $("#textbox").val(update);
    }
  });
}

async function fetchCalendarData(search = "") {
  try {
    if (!response) {
      response = await gapi.client.sheets.spreadsheets.values.get({
        spreadsheetId: SPREADSHEET,
        range: RANGE
      })
      if (ENABLE_CACHING) {
        try {
          //window['localStorage'].clear()
          window['localStorage'].setItem('gsheetsResponse' + START_DATE, JSON.stringify(response))
          window['localStorage'].setItem('gsheetsResponseTimestamp' + START_DATE, (new Date()).toISOString())
          window['localStorage'].setItem('gsheetsResponseGeneration' + START_DATE, JSON.stringify(API_CACHE_GENERATION))
        } catch (err) {
          // do nothing. someone wants to be a jerk and waste our Google Sheets API calls.
          console.log(err);
        }
      }
    }
  } catch (err) {
    document.getElementById('example').innerText = err.message
    return
  }
  const range = response.result
  if (!range || !range.values || range.values.length == 0) {
    document.getElementById('example').innerText = 'No values found.'
    return
  }

  sheetsData = []

  var empties = 0
  for (const event of range.values) {
    if (event.length < 6) {
      if (empties > 10) { break }
      empties += 1
      continue
    } else { empties = 0 }
    if (event[0].length == 0) {
      continue
    }

    const [title, people, detail, start_, end_, location, priority_]: string[] = event
    if ((title + people + detail + '[' + location + ']').toLowerCase().indexOf(search.toLowerCase()) < 0) continue;
    const start = new Date(start_);
    const end = new Date(end_);
    if (isNaN(start.valueOf()) || isNaN(end.valueOf())) continue;
    const priority = priority_ ? +priority_ : Infinity
    sheetsData.push({
      title,
      people,
      detail,
      start,
      end,
      location,
      priority,
    })
  }
  sheetsData.sort((a, b) => a.priority - b.priority)
  importSheets(sheetsData)
}

let signalJsIsLoaded

const jsLoaded = new Promise(function (resolve, reject) {
  signalJsIsLoaded = resolve
})

function gapiLoaded() {
  gapi.load('client', initializeGapiClient)
}
window.gapiLoaded = gapiLoaded

async function initializeGapiClient() {
  await jsLoaded
  await gapi.client.init({
    apiKey: API_KEY,
    discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4']
  })
  await fetchCalendarData()
  await updateLocationFilter()
}

$script([
  'https://kendo.cdn.telerik.com/2022.2.510/js/jquery.min.js',
  'https://kendo.cdn.telerik.com/2022.2.510/js/kendo.all.min.js',
  'https://cdn.jsdelivr.net/npm/ical.js@1.4.0/build/ical.min.js'
], function () {
  console.log('loadedjs')
  // Create a blank Scheduler

  // DataSource schema for iCal support (id is string instead of number)
  kendo.data.schemas['scheduler-ical'] = {
    model: {
      id: 'id',
      fields: {
        id: {
          type: 'string'
        },
        title: {
          defaultValue: '',
          type: 'string'
        },
        start: {
          type: 'date'
        },
        startTimezone: {
          type: 'string'
        },
        end: {
          type: 'date'
        },
        endTimezone: {
          type: 'string'
        },
        recurrenceRule: {
          defaultValue: '',
          type: 'string'
        },
        recurrenceException: {
          defaultValue: '',
          type: 'string'
        },
        isAllDay: {
          type: 'boolean',
          defaultValue: false
        },
        description: {
          type: 'string'
        },
        location: {
          type: 'string',
          defaultValue: ''
        },
      }
    }
  }
  let firstTime = true
  $("#textbox").kendoAutoComplete({
    placeholder: "Search ...",
    popup: {
      appendTo: $("#hidden")
    },
    filtering: function handler() {
      fetchCalendarData(this.value())
    }
  });
  $('#scheduler').text('').kendoScheduler({
    change: scheduler_change,
    destroy: function () {
      return false
    },
    dataBound: function () {
      setTimeout(function () {
        if (firstTime) {
          firstTime = false
          // seturl
          // $('.k-scheduler-search input').val(location.hash.substring(1)).trigger('change')
        }
      }, 1000)
    },
    selectable: true,
    editable: false,
    eventTemplate: '<span style="color:#= start.getDay() % 2 == 0 ? "\\#009" : "\\#000" #">#= title #</span>',
    startTime: new Date(START_DATE + '08:00'),
    endTime: new Date(END_DATE + '21:00'),
    date: new Date(START_DATE),
    views: [{
      type: 'agenda',
      selected: true
    }],
    timezone: 'Etc/UTC'
  })

  // Handle export button click.
  $('#exportButton').on('click', function (ev) {
    ev.preventDefault()
    exportICal()
  })

  $('#printButton').on('click', function (ev) {
    ev.preventDefault()
    var scheduler = $('#scheduler').data('kendoScheduler');
    //schedule.saveAsPDF()
    var drawing = kendo.drawing;

    //workaround PDF export rowspan limitation
    $(".k-scheduler-content table [rowspan]").each(function() {
      var currentCell = $(this);
      var rowSpan = parseInt(currentCell.attr("rowspan"));
      var currentRow = currentCell.closest("tr");

      var nextRow = currentRow.next();
      for (var i = 0; i < rowSpan - 2; i++) {
        nextRow = nextRow.next();
        nextRow.prepend($("<td class='inserted'></td>"));
      }

      currentCell.attr("rowspan", 2);
    })

    drawing.drawDOM("#scheduler .k-scheduler-content", {
      paperSize: "Letter",
      margin: "2cm",
      scale: 0.7,
    }).then(function(group){
      drawing.pdf.saveAs(group, "scheduler_agenda.pdf");
      scheduler.view(scheduler.view().name);
    });
  })

  signalJsIsLoaded()
})

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

function importSheets(sheetsData: { title: string; people: string; detail: string; start: Date; end: Date; location: string; priority: number }[]) {
  const scheduler = $('#scheduler').data('kendoScheduler')

  const data = sheetsData.map(function (event: { title: string; people: string; detail: string; start: Date; end: Date; location: string; priority: number }/*, id */) {
    const title = '<b>' + event.title + '</b> ' + event.people + ' [' + event.location + ']'
    const description = event.detail
    const location = event.location
    const id = kendo.guid()
    const start = event.start
    const end = event.end
    return {
      id,
      start,
      end,
      title,
      description,
      location
    }
  })

  scheduler.setDataSource(new kendo.data.SchedulerDataSource({
    data, schema: kendo.data.schemas['scheduler-ical']
  }))
}

function importICal(iCalData) {
  const scheduler = $('#scheduler').data('kendoScheduler')
  const data = []
  const jcalData = ICAL.parse(iCalData)
  const vcalendar = new ICAL.Component(jcalData)
  const components = vcalendar.getAllSubcomponents('vevent')

  for (let i = 0; i < components.length; i++) {
    const event = new ICAL.Event(components[i])
    let recurrenceRule = null
    let recurrenceException = null

    if (event.isRecurring()) {
      const recur = new ICAL.Recur(event.component.getFirstProperty('rrule'))
      recurrenceRule = recur.getFirstValue().toString()
    }

    if (event.component.getFirstProperty('exdate')) {
      recurrenceException = event.component.getFirstProperty('exdate').getFirstValue().toICALString()
    }

    data.push({
      id: event.isRecurrenceException() ? kendo.guid() : event.uid,
      title: event.summary,
      description: event.description,
      start: event.startDate.toString(),
      startTimezone: getTimeZone(event.startDate.timezone),
      end: event.endDate.toString(),
      endTimezone: getTimeZone(event.endDate.timezone),
      recurrenceRule,
      recurrenceId: event.isRecurrenceException() ? event.uid : null,
      recurrenceException
    })
  }

  scheduler.setDataSource(new kendo.data.SchedulerDataSource({
    data,
    schema: kendo.data.schemas['scheduler-ical']
  }))
}

function exportICal() {
  const scheduler = $('#scheduler').data('kendoScheduler')
  const component = new ICAL.Component(['vcalendar', [],
    []
  ])
  component.updatePropertyWithValue('prodid', '-//iCal.js Example')
  component.updatePropertyWithValue('version', '2.0')

  const schedulerEvents = scheduler.dataSource.view().toJSON()

  for (const schedulerEvent of schedulerEvents) {
    const vevent = new ICAL.Component('vevent')
    const event = new ICAL.Event(vevent)

    event.uid = schedulerEvent.recurrenceId ? schedulerEvent.recurrenceId : schedulerEvent.id
    event.summary = schedulerEvent.title.replace(/#/g, 'number ')
    event.description = schedulerEvent.description.replace(/#/g, 'number ').replace(/<a/g, '')
    if (schedulerEvent.location) { event.location = schedulerEvent.location }
    event.startDate = ICAL.Time.fromJSDate(schedulerEvent.start, true)
    event.endDate = ICAL.Time.fromJSDate(schedulerEvent.end, true)

    if (schedulerEvent.recurrenceRule) {
      event.component.addProperty(
        new ICAL.Property(ICAL.parse.property('RRULE:' + schedulerEvent.recurrenceRule)))
    }

    if (schedulerEvent.recurrenceException) {
      event.component.addProperty(
        new ICAL.Property(ICAL.parse.property('EXDATE:' + schedulerEvent.recurrenceException)))
    }

    if (schedulerEvent.recurrenceId) {
      event.recurrenceId = ICAL.Time.fromJSDate(schedulerEvent.start, true)
    }

    event.component.addPropertyWithValue('dtstamp',
      ICAL.Time.fromJSDate(new Date(), true))

    component.addSubcomponent(vevent)
  }

  kendo.saveAs({
    dataURI: 'data:text/calendar;base64,' + btoa(unescape(encodeURIComponent(component.toString()))),
    fileName: 'PorcfestOfflineSchedule.ics'
  })
}

function getTimeZone(timezone) {
  return timezone.toLowerCase() === 'z' ? null : timezone
}

function getISOString(date, toUTC) {
  return kendo.toString(date, 'yyyy-MM-ddTHH:mm:ssZ')
}
